<template>
  <v-form>
    <v-alert
      v-model="isError"
      dismissible
      type="error"
      transition="fade-transition"
    >
      {{ errMessage }}
    </v-alert>
    <church-select
      v-model="churchID"
      required
      :error-messages="errors.churchID"
      id="churchID"
      @focus="inputFocus"
    />
    <v-text-field
      v-model="firstName"
      label="First Name"
      :error-messages="errors.firstName"
      id="firstName"
      @focus="inputFocus"
    />
    <v-text-field
      v-model="lastName"
      label="Last Name"
      :error-messages="errors.lastName"
      id="lastName"
      @focus="inputFocus"
    />
    <v-select
      v-model="gender"
      label="Gender"
      :items="genderOptions"
      :error-messages="errors.gender"
      id="gender"
      @focus="inputFocus"

      v-if="showGender"
    />
    <v-btn
      @click="submit"
      id="submit"
    >{{ this.admin === true ? 'Update Role Data' : 'Begin' }}</v-btn>
  </v-form>
</template>

<script>
import ChurchSelect from './church-select'

export default {
  name: 'SetupChurchMember',
  data: () => ({
    _userID: null,
    churchID: null,
    firstName: null,
    lastName: null,
    gender: null,
    genderOptions: [
      { text: 'Prefer Not to Answer', value: '' },
      { text: 'Female', value: 'F' },
      { text: 'Male', value: 'M' }
    ],
    isError: false,
    errMessage: null,
    errors: {
      churchID: null,
      firstName: null,
      lastName: null,
      gender: null
    }
  }),
  props: {
    // If true, the submission doesn't perform any redirects
    admin: {
      type: Boolean,
      default: false
    },
    userID: {
      type: String,
      default: null
    },
    showGender: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    userID: function () {
      this._userID = this.userID
    }
  },
  methods: {
    submit: function () {
      var _this = this

      // Start by saving the optional name and gender information, since they
      // can be safely overwritten if the subsequent role association call fails
      let reqs = [
        this.axios.put('/auth/users/' + this._userID + '/name', {
          firstName: this.firstName,
          lastName: this.lastName
        })
      ]
      if (this.showGender) {
        reqs.push(this.axios.put('/auth/users/' + this._userID + '/gender', {
          gender: this.gender
        }))
      }

      this.axios.all(reqs)
        .then(function () {
          // Now try to create our role association
          _this.axios.post('/churches/' + _this.churchID + '/members/' + _this._userID)
            .then(function () {
              // Update our user information (new role) if appropriate
              if (_this.admin === false) {
                _this.$auth.fetch({ success: function () {
                  // Now that our user has a role, they can visit other pages
                  _this.$router.push('/account')
                } })
              }
            })
            .catch(_this.$root.apiErrorHandler(function (msg, errors) {
              _this.errMessage = msg
              _this.errors = errors
              _this.isError = true
            }))
        })
        .catch(_this.$root.apiErrorHandler(function (msg, errors) {
          _this.errMessage = msg
          _this.errors = errors
          _this.isError = true
        }))
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  },
  mounted () {
    // Make sure that our internal userID value starts out as equal with our prop value
    this._userID = this.userID

    // Make sure we know the ID of the user we're working with
    // If this isn't an admin situation and the userID prop hasn't already been
    // set, we can use the logged-in user's ID, assuming setup
    if (this.admin === false && this.userID === null) {
      this._userID = this.$auth.user().id
    }

    // Try to load existing data for the user if appropriate
    if (this._userID !== null) {
      let _this = this
      this.axios.get('/auth/users/' + this._userID)
        .then(function (res) {
          if (res.data && res.data.length > 0) {
            let user = res.data[0]
            _this.firstName = user.firstName
            _this.lastName = user.lastName
            if (user.churchID) {
              _this.churchID = user.churchID
            }
          }
        })
        .catch(this.$root.apiErrorHandler())
    }
  },
  components: {
    ChurchSelect
  }
}
</script>
